 


window.addEventListener("DOMContentLoaded",()=>{
    const MAX_WAIT_TIMEQuickAddTest = 5000;
  
    const startTimeQuickAddTest = Date.now();
  
    const checkIntervalQuickAddTest = setInterval(() => {
      const itemValueQuickAddTest = localStorage.getItem('data-quick-add-test');
  
      if (itemValueQuickAddTest) {
        document.body.setAttribute('data-quick-add-test','true')
        console.log("Quick add test found. Dismissing immediately...");
        clearInterval(checkIntervalQuickAddTest);
      } 
      else if (Date.now() - startTimeQuickAddTest >= MAX_WAIT_TIMEQuickAddTest) {
        console.log("Quick add test not found within 5s. Dismissing...");
        clearInterval(checkIntervalQuickAddTest);
      }
    }, 50);
    const allCustomProductItems= document.querySelectorAll(".CustomProductItem");
    
        allCustomProductItems.forEach(CustomProductItem=>{
            const quickAtcToggleWrapper=CustomProductItem.querySelector(".custom_new_quick_atc_toggle_wrapper");

            if(quickAtcToggleWrapper){

                    CustomProductItem.addEventListener("mouseenter",()=>{
                        if(document.body.getAttribute('data-quick-add-test') && window.innerWidth >=992){
                            CustomProductItem.classList.add("active-product-item")
                            quickAtcToggleWrapper.setAttribute("data-toggle","-")
                        }
                        
                        
                        })
                        
                    CustomProductItem.addEventListener("mouseleave",()=>{
                        if(document.body.getAttribute('data-quick-add-test')&& window.innerWidth >=992){
                            
                        CustomProductItem.classList.remove("active-product-item")
                        quickAtcToggleWrapper.setAttribute("data-toggle","+")
                        }
                            
                        })
                
               /* else{

                    if(document.body.getAttribute('data-quick-add-test') =="a"){

                        CustomProductItem.querySelector('.custom_new_quick_atc_toggle_wrapper').addEventListener("click",()=>{
                           
                            if(!CustomProductItem.classList.contains('active-product-item')){
                                CustomProductItem.classList.add("active-product-item")
                                quickAtcToggleWrapper.setAttribute("data-toggle","-")
                            }
                            else{  

                                CustomProductItem.classList.remove("active-product-item")
                                quickAtcToggleWrapper.setAttribute("data-toggle","+")

                            }

                                
                                })



                    }
                    else if (document.body.getAttribute('data-quick-add-test') =="b"){
                        if( CustomProductItem.querySelector('.quick__add_wrapper')){

                            CustomProductItem.querySelector('.quick__add_wrapper').addEventListener("click",()=>{

                                CustomProductItem.classList.toggle("active-product-item")
                            
                            
                            })
                        }
                       

                    }

                }*/

               
        
            }
                
    
        })
})

